import { useIntl } from '@/intl'
import { useFilters } from '@/scopes/search/search/domain/hooks'

import { CustomerRatingChips } from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersChipsLegacy/CustomerRatingChips'

import { NumberOfRoomsChips } from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersChipsLegacy/NumberOfRoomsChips'
import { StarsChips } from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersChipsLegacy/StarsChips'

import { Button, tk } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { AccommodationTypeChips } from './AccomodationTypeChips'
import { ChildrenFacilitiesChips } from './ChildrenFacilitiesChips'
import { CollectionChips } from './CollectionChips'
import { DealChips } from './DealChips'
import { DistanceToInterestChips } from './DistanceToInterestChips'
import { FacilitiesChips } from './FacilitiesChips'
import { MealPlanChips } from './MealPlanChips'
import { PricePerPersonChips } from './PricePerPersonChips'
import { InternetFacilitiesChips } from './TnternetFacilitiesChips'
import { VacationTypeChips } from './VacationTypeChips'

const ResetFiltersButton = styled(Button)`
  &:first-child:last-child {
    display: none;
  }
`

const Wrapper = styled.div`
  margin-bottom: ${tk('spacing_md')};

  > * {
    margin-right: ${tk('spacing_xs')};
    margin-bottom: ${tk('spacing_xs')};
  }
`

export function SelectedFiltersChipsLegacy({ withResetButton }: { withResetButton?: boolean }) {
  const intl = useIntl()
  const { resetOptionalFilters } = useFilters()

  return (
    <Wrapper>
      <AccommodationTypeChips />
      <MealPlanChips />
      <DealChips />
      <FacilitiesChips />
      <StarsChips />
      <CustomerRatingChips />
      <ChildrenFacilitiesChips />
      <InternetFacilitiesChips />
      <VacationTypeChips />
      <NumberOfRoomsChips />
      <DistanceToInterestChips />
      <CollectionChips />
      <PricePerPersonChips />
      {withResetButton && (
        <ResetFiltersButton $hierarchy="tertiary" $size="small" $withoutColor onClick={resetOptionalFilters}>
          {intl.formatMessage({
            id: 'search_reset_filters',
          })}
        </ResetFiltersButton>
      )}
    </Wrapper>
  )
}
